import type { FC } from "react";

import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { translate } from "app/filters/i18nFilter";
import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";

import { Header, Title } from "./styledComponents";

interface TitleFiltersProps {
    title: string;
}
const TitleFilters: FC<TitleFiltersProps> = ({ title }) => {
    const subtitleFilters = useSubtitleFilters("date", "country", "webSource");

    return (
        <Header>
            <Title>{translate(title)}</Title>
            <StyledBoxSubtitle>
                <BoxSubtitle filters={subtitleFilters} />
            </StyledBoxSubtitle>
        </Header>
    );
};

export default TitleFilters;
